import React from 'react'
import { ImageProps } from 'next/legacy/image'
import NextOptimizedImage from '@package/ds/next-image'
import { APP_ENV } from '~/config/env'

export const OptimizedImage = (props: ImageProps) => (
  <NextOptimizedImage appEnv={APP_ENV} {...props} />
)
